//
//
//
//
//
//
//
//
//

import ImageZoom from "@/components/ImageZoom";
export default {
  name: "FileContainer",
  components: { ImageZoom },
  props:  {
    src: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    description: {
      type: String,
      required: false
    }
  },
  computed: {
    isImage() {
      return this.src.endsWith('.png')
          || this.src.endsWith('.jpg')
          || this.src.endsWith('.jpeg')
          || this.src.endsWith('.gif')
          || this.src.endsWith('.webp')
    }
  }
}
